import React, { useEffect } from 'react'
import LoginPage from './pages/LoginPage'
import MainPage from './pages/MainPage'
import SideBar from './components/sidebar/SideBar'
import { Route, Routes, useNavigate } from 'react-router-dom'
import MainModal from './components/modals/MainModal'
import { useDispatch, useSelector } from 'react-redux'
import Loader from './components/Loader'
import { getLoginUser } from './actions/MainAction'
import ContentPage from './pages/ContentPage'
import AboutPage from './pages/AboutPage'
import ActivitiesPage from './pages/ActivitiesPage'
import DonatesPage from './pages/DonatesPage'
import FocusAreasPage from './pages/FocusAreasPage'
import ProjectsPage from './pages/ProjectsPage'
import VolunteeringPage from './pages/VolunteeringPage'
import LanguagePage from './pages/LanguagePage'
import Profile from './pages/Profile'

function App() {
  const loader = useSelector(state=>state.Data.loader)
  const mainModal = useSelector(state=>state.Data.mainModal)
  const user = useSelector(state=> state.Data.user);

  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(getLoginUser())
    .then(resp=>{
      if(resp == "error"){
        navigate("/login")
      }
    })
  },[])
  return (
    <div className='flex'>
      {user !=""? <SideBar /> : null}
      
      <Routes>
        <Route path='/login' element={ <LoginPage />} />
        <Route path='/' element={ <MainPage />} />
        <Route path='/content' element={ <ContentPage/>} />
        <Route path='/about-founder' element={ <AboutPage/>} />
        <Route path='/activities' element={ <ActivitiesPage/>} />
        <Route path='/donates' element={ <DonatesPage/>} />
        <Route path='/focus-areas' element={ <FocusAreasPage/>} />
        <Route path='/projects' element={ <ProjectsPage/>} />
        <Route path='/volunteering' element={ <VolunteeringPage/>} />
        <Route path='/language' element={ <LanguagePage/>} />
        <Route path='/profile' element={ <Profile/>} />
       
      </Routes>
      {mainModal?.position? <MainModal /> :null}
      {loader? <Loader />:null}
    </div>
  )
}

export default App